import { IQueryStringNavLinks } from "../../interfaces-and-types";
import { View } from "./View";

export const Revenue = () => {
  const queryStringTabs: IQueryStringNavLinks = {
    query: "",
    options: [
      {
        key: "Revenue Recognition",
        value: "",
      },
    ],
  };

  return <View queryStringTabs={queryStringTabs} />;
};
